module.exports = __webpack_public_path__ + "media/img/news-3-593ce4ba.png";